var _ellipse, _path, _path2, _path3, _g, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendlePtReth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_660)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.399,
    cy: 124.961,
    rx: 106,
    ry: 108.5,
    transform: "rotate(-3 117.399 124.961)",
    fill: "url(#paint0_linear_28_660)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_660",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 10,
    width: 226,
    height: 229
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.164 10.1402L21.4575 21.3401L32.8144 238.043L246.521 226.843L235.164 10.1402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_660)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.668 232.443C198.681 229.35 243.979 178.332 240.843 118.491C237.707 58.6509 187.324 12.6474 128.311 15.7401C69.2975 18.8329 23.9999 69.8508 27.136 129.691C30.2721 189.532 80.6544 235.536 139.668 232.443Z",
    fill: "url(#paint1_radial_28_660)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_28_660",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 15,
    width: 215,
    height: 218
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.668 232.443C198.681 229.35 243.979 178.332 240.843 118.491C237.707 58.6509 187.324 12.6474 128.311 15.7401C69.2975 18.8329 23.9999 69.8508 27.136 129.691C30.2721 189.532 80.6544 235.536 139.668 232.443Z",
    fill: "url(#paint2_radial_28_660)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_28_660)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.0188 81.1199C20.8933 78.7265 22.7052 76.6856 25.0658 76.5619L83.4789 73.5006C85.8393 73.3769 87.8548 75.2172 87.9802 77.6106L93.2612 178.377C93.3866 180.771 91.5746 182.812 89.2142 182.935L30.801 185.997C28.4405 186.12 26.4252 184.28 26.2997 181.887L21.0188 81.1199Z",
    fill: "url(#paint3_linear_28_660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.098 161.579C157.972 159.186 159.784 157.145 162.145 157.021L238.367 153.027C240.727 152.903 242.743 154.743 242.868 157.137L244.836 194.699C244.962 197.092 243.15 199.133 240.789 199.257L164.567 203.251C162.207 203.375 160.192 201.535 160.066 199.141L158.098 161.579Z",
    fill: "#E74310"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M208.212 170.542C210.572 170.418 212.588 172.259 212.713 174.652L216.537 247.609C216.662 250.002 214.85 252.043 212.49 252.167L184.352 253.641C181.991 253.765 179.976 251.925 179.85 249.531L176.027 176.575C175.902 174.181 177.714 172.141 180.074 172.017L208.212 170.542Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M111.7 87.2325C114.06 87.1088 116.076 88.9491 116.201 91.3425L119.248 149.491C119.374 151.885 117.562 153.925 115.201 154.049L83.5016 155.71C81.1412 155.834 79.1257 153.994 79.0003 151.6L75.9528 93.4518C75.8274 91.0584 77.6395 89.0175 79.9998 88.8938L111.7 87.2325Z",
    fill: "url(#paint4_linear_28_660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M46.3591 108.041C46.2337 105.647 48.0456 103.606 50.4061 103.483L102.408 100.757C104.768 100.634 106.784 102.474 106.909 104.867L109.805 160.127C109.931 162.52 108.119 164.561 105.758 164.685L53.7564 167.41C51.3958 167.534 49.3805 165.693 49.2551 163.3L46.3591 108.041Z",
    fill: "url(#paint5_linear_28_660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M236.716 39.7562C239.077 39.6325 241.092 41.4726 241.218 43.8662L245.041 116.823C245.167 119.216 243.354 121.257 240.994 121.381L174.745 124.853C172.385 124.976 170.369 123.136 170.244 120.743L166.42 47.7862C166.295 45.3926 168.107 43.3519 170.467 43.2282L236.716 39.7562Z",
    fill: "#FF9776"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.932 -6.53134C196.292 -6.65504 198.308 -4.81491 198.433 -2.42129L202.635 77.7587C202.761 80.1522 200.949 82.193 198.588 82.3167L161.546 84.258C159.185 84.3817 157.17 82.5415 157.045 80.148L152.842 -0.0319761C152.717 -2.4256 154.529 -4.46632 156.889 -4.59003L193.932 -6.53134Z",
    fill: "#FFCA8C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.923 6.90747C216.283 6.78377 218.298 8.6239 218.424 11.0175L223.099 100.227C223.225 102.62 221.413 104.661 219.052 104.785L138.556 109.003C136.196 109.127 134.18 107.287 134.055 104.893L129.379 15.6842C129.254 13.2905 131.066 11.2498 133.426 11.1261L213.923 6.90747Z",
    fill: "url(#paint6_linear_28_660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M95.4151 -12.2332C97.7755 -12.3569 99.7909 -10.5168 99.9164 -8.12314L103.058 51.8312C103.184 54.2247 101.372 56.2656 99.0115 56.3893L70.8734 57.8639C68.513 57.9877 66.4976 56.1474 66.3721 53.7539L63.2301 -6.20049C63.1046 -8.59412 64.9167 -10.6348 67.2771 -10.7585L95.4151 -12.2332Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.369 173.602C110.729 173.478 112.745 175.318 112.87 177.712L115.577 229.359C115.702 231.753 113.89 233.794 111.53 233.917L39.9381 237.669C37.5775 237.793 35.5622 235.953 35.4368 233.559L32.7301 181.912C32.6046 179.518 34.4165 177.477 36.7771 177.354L108.369 173.602Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M169.898 141.404C172.258 141.281 174.274 143.121 174.399 145.514L178.62 226.055C178.746 228.449 176.934 230.49 174.573 230.613L92.6523 234.907C90.2919 235.03 88.2764 233.19 88.151 230.797L83.93 150.256C83.8046 147.862 85.6166 145.821 87.977 145.698L169.898 141.404Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.147 15.3295C138.507 15.2058 140.523 17.0459 140.648 19.4395L141.746 40.3875C141.871 42.7811 140.059 44.8218 137.699 44.9455L52.2161 49.4255C49.8556 49.5492 47.8403 47.709 47.7149 45.3154L46.617 24.3675C46.4916 21.9739 48.3035 19.9332 50.664 19.8094L136.147 15.3295Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.9858 233.455L231.549 62.7523L225.767 57.4733L74.2043 228.176L79.9858 233.455Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M67.3591 222.269L218.922 51.5667L211.395 44.6935L59.8318 215.396L67.3591 222.269Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.2059 215.05L211.769 44.3475L204.242 37.4744L52.6786 208.177L60.2059 215.05Z",
    fill: "#F45C2C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.3783 207.44L204.941 36.7378L198.746 31.081L47.1831 201.783L53.3783 207.44Z",
    fill: "#F45C2C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M47.1699 201.771L198.733 31.0687L192.538 25.412L40.9747 196.114L47.1699 201.771Z",
    fill: "#FFBC6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.8356 194.031L194.399 23.3283L188.203 17.6715L36.6404 188.374L42.8356 194.031Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M21.4596 147.345L140.968 12.745L134.773 7.08823L15.2644 141.689L21.4596 147.345Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M14.3127 140.46L133.822 5.85968L127.626 0.202911L8.11751 134.803L14.3127 140.46Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M7.82236 132.47L127.331 -2.12994L121.136 -7.78671L1.62715 126.814L7.82236 132.47Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.344 164.218L171.146 7.88733L164.951 2.23056L26.1488 158.561L32.344 164.218Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.754 173.403L175.556 17.0724L169.361 11.4157L30.5588 167.746L36.754 173.403Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.28 153.454L152.472 14.7063L146.276 9.04953L23.0848 147.798L29.28 153.454Z",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.7561 233.588L231.319 62.8861L218.959 51.6006L67.3964 222.303L79.7561 233.588Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.7561 233.588L231.319 62.8861L218.896 51.5431L67.3334 222.245L79.7561 233.588Z",
    fill: "#DF3600"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.057 147.479L93.1247 125.223L130.195 54.7068L174.396 120.964L135.057 147.479Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.232 188.999L93.5358 133.068L135.466 155.287L174.844 128.807L137.232 188.999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M234.238 118.838C237.236 176.031 194.389 224.568 138.793 227.482C83.1981 230.395 35.5124 186.603 32.515 129.409C29.5176 72.2159 72.3646 23.679 127.96 20.7654C183.555 17.8517 231.241 61.6441 234.238 118.838Z",
    stroke: "url(#paint7_linear_28_660)",
    strokeWidth: 10
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 50,
    r: 50,
    fill: "url(#paint8_radial_28_660)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.747 33.1472C189.006 33.1472 191.002 33.6555 192.734 34.6722C194.504 35.6889 195.859 37.1197 196.801 38.9648C197.78 40.8099 198.269 42.9185 198.269 45.2907C198.269 47.6253 197.78 49.6963 196.801 51.5037C195.859 53.2734 194.504 54.6478 192.734 55.6268C191.002 56.6058 189.006 57.0954 186.747 57.0954H180.647C180.459 57.0954 180.365 57.1895 180.365 57.3778V72.0629C180.365 72.2512 180.289 72.4207 180.139 72.5713C180.026 72.6842 179.875 72.7407 179.687 72.7407H173.078C172.89 72.7407 172.721 72.6842 172.57 72.5713C172.457 72.4207 172.401 72.2512 172.401 72.0629V33.825C172.401 33.6367 172.457 33.4861 172.57 33.3731C172.721 33.2225 172.89 33.1472 173.078 33.1472H186.747ZM185.448 50.7694C186.916 50.7694 188.084 50.2987 188.95 49.3574C189.853 48.3784 190.305 47.0793 190.305 45.4602C190.305 43.8034 189.853 42.4855 188.95 41.5065C188.084 40.5274 186.916 40.0379 185.448 40.0379H180.647C180.459 40.0379 180.365 40.1321 180.365 40.3204V50.487C180.365 50.6753 180.459 50.7694 180.647 50.7694H185.448ZM227.145 33.2037C227.334 33.2037 227.484 33.279 227.597 33.4296C227.748 33.5426 227.823 33.6932 227.823 33.8815V39.4166C227.823 39.6049 227.748 39.7744 227.597 39.925C227.484 40.0379 227.334 40.0944 227.145 40.0944H218.56C218.372 40.0944 218.278 40.1886 218.278 40.3768V72.0629C218.278 72.2512 218.202 72.4207 218.052 72.5713C217.939 72.6842 217.788 72.7407 217.6 72.7407H210.992C210.803 72.7407 210.634 72.6842 210.483 72.5713C210.37 72.4207 210.314 72.2512 210.314 72.0629V40.3768C210.314 40.1886 210.22 40.0944 210.031 40.0944H201.729C201.54 40.0944 201.371 40.0379 201.22 39.925C201.107 39.7744 201.051 39.6049 201.051 39.4166V33.8815C201.051 33.6932 201.107 33.5426 201.22 33.4296C201.371 33.279 201.54 33.2037 201.729 33.2037H227.145Z",
    fill: "#1C293A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.088 250C227.654 250 250 227.614 250 200C250 172.386 227.654 150 200.088 150C172.522 150 150.176 172.386 150.176 200C150.176 227.614 172.522 250 200.088 250Z",
    fill: "url(#paint9_radial_28_660)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_28_660",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 150,
    width: 100,
    height: 100
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.912 250C227.478 250 249.824 227.614 249.824 200C249.824 172.386 227.478 150 199.912 150C172.346 150 150 172.386 150 200C150 227.614 172.346 250 199.912 250Z",
    fill: "#DEDEDE"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_28_660)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.458 274.996C192.622 274.996 204.916 262.681 204.916 247.489C204.916 232.298 192.622 219.983 177.458 219.983C162.293 219.983 149.999 232.298 149.999 247.489C149.999 262.681 162.293 274.996 177.458 274.996Z",
    fill: "#152E51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_28_660",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 152,
    width: 7,
    height: 75
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.437 226.554V152.836H180.558V226.554H174.437Z",
    fill: "#152E51"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_28_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.824 200C249.824 227.615 227.478 250 199.912 250C172.346 250 150 227.615 150 200C150 172.386 172.346 150 199.912 150C227.478 150 249.824 172.386 249.824 200Z",
    fill: "#152E51"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_660",
    x1: 117.399,
    y1: 16.4609,
    x2: 117.399,
    y2: 233.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB572C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_28_660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.9846 69.5095) rotate(51.5452) scale(178.93 178.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5A37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_28_660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.9846 69.5095) rotate(51.5452) scale(178.93 178.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_660",
    x1: 54.2723,
    y1: 75.0312,
    x2: 60.0076,
    y2: 184.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE090",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_660",
    x1: 95.6717,
    y1: 88.0725,
    x2: 98.9084,
    y2: 149.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_28_660",
    x1: 47.8219,
    y1: 135.953,
    x2: 103.79,
    y2: 133.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_28_660",
    x1: 173.675,
    y1: 9.01679,
    x2: 178.804,
    y2: 106.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_660",
    x1: 127.698,
    y1: 15.7722,
    x2: 139.055,
    y2: 232.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_28_660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.241 23.6111) rotate(134.346) scale(86.1024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0E2FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_28_660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174 230.5) rotate(-52.0284) scale(78.0144 77.8771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendlePtReth);
export default __webpack_public_path__ + "static/media/pendle-pt-reth.a11557eb946eaef1bedda98e43056a89.svg";
export { ForwardRef as ReactComponent };